import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { UiService } from '@state/ui/ui.service';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { ToastService } from '@core/services/toast/toast.service';
import { LibraryService } from '@core/services/library/library.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    private requestCount = 0;

    constructor(
        private libraryService: LibraryService,
        private toastService: ToastService,
        private uiService: UiService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timeoutValue = req.headers.get('timeout') || 30000;
        const timeoutValueNumeric = Number(timeoutValue);

        if (this.requestCount === 0) {
            this.uiService.setLoading(true);
        }

        this.requestCount++;

        return next.handle(req).pipe(
            timeout(timeoutValueNumeric),
            catchError(err => {
                if (err instanceof TimeoutError) {
                    this.toastService.presentErrorToast(this.libraryService.getLabel('lbl_timeout'));
                }

                return throwError(() => err);
            }),
            finalize(() => {
                this.requestCount--;

                if (this.requestCount <= 0) {
                    this.requestCount = 0; // Resetear a 0 en caso de underflow
                    this.uiService.setLoading(false);
                }
            })
        );
    }
}
